import Vue from 'vue'
import './plugins/axios'
import './plugins/Tiptap'
import App from './App.vue'
//import vuetify from './plugins/vuetify';
import './registerServiceWorker'
import router from './router'
import store from './store'
import * as firebase from "firebase";

import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import GmapCustomMarker from "vue2-gmap-custom-marker";
import VStickyElement from "vue-sticky-element";
Vue.config.productionTip = false;
Vue.use(GmapCustomMarker);
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);
Vue.use(VStickyElement);

Vue.config.productionTip = false

const configOptions = {
  /*apiKey: "AIzaSyCcy9EWC9o4BtaTiUveJ1lWwvlEcGNPYro",
  authDomain: "hrcrm-439b3.firebaseapp.com",
  databaseURL: "https://hrcrm-439b3.firebaseio.com",
  projectId: "hrcrm-439b3",
  storageBucket: "hrcrm-439b3.appspot.com",
  messagingSenderId: "188965616817",
  appId: "1:188965616817:web:ff1a5dcee919c435c1f690",
  measurementId: "G-YQSMMXSE85"*/
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_FIREBASE_DATASE_URL,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGE_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_APP_ID,
  measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID
};
firebase.initializeApp(configOptions);
//const messaging = firebase.messaging();
//messaging.usePublicVapidKey("BPrlyuzI7mlg19TkO1UbMaIPJ2XqGKBhzuGORPxVoqk0dYddDfPLm4OuP0_GncEbSoub4292jYDULVFN-oxLbPE")


firebase.auth().onAuthStateChanged(user => {
  store.dispatch("fetchUser", user);
  
  if (user) {
    // user is logged in so openDBChannel
    store.dispatch('userData/openDBChannel')
      .catch(console.error)
    // or fetchAndAdd
    // store.dispatch('userData/fetchAndAdd')
  }
});

firebase.getCurrentUser = () => {
  return new Promise((resolve, reject) => {
      const unsubscribe = firebase.auth().onAuthStateChanged(user => {
          unsubscribe();
          resolve(user);
      }, reject);
  })
};

Vue.prototype.$firebase = firebase;




new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')








